/**
 * ResizeTypes  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { MouseOrTouchEvent } from "@adapptio/lib-components";

export type ResizeElementId = string;

export type ResizeEvent = MouseOrTouchEvent;

export enum RESIZE_DIRECTION {
	HORIZONTAL = "horizontal",
	VERTICAL = "vertical"
}

export enum RESIZE_COMPONENT_TYPE {
	HANDLE = "handle",
	ELEMENT = "element"
}

export interface IResizeEventData {
	offset: number;
	direction: {
		horizontal: boolean;
		vertical: boolean;
	};
	resizing: boolean;
	resizedElementsIds: ResizeElementId[];
	newSize?: number;
}

export type ResizeHandler = (data: IResizeEventData) => void;

export interface IResizeElementData {
	id: ResizeElementId;
	type: RESIZE_COMPONENT_TYPE;
	size?: number | string;
	minSizePx?: number;
	ref?: React.MutableRefObject<HTMLElement>;
	registered?: boolean;
	resizeDisabled?: boolean;
	onResizeStart?: ResizeHandler;
	onResize?: ResizeHandler;
	onResizeStop?: ResizeHandler;
	onDataUpdate?: (allData: Array<{ id: ResizeElementId; resizeDisabled?: boolean }>) => void;
}

export interface IResizeContext {
	onStartResize?: (elementId: ResizeElementId, event: ResizeEvent, splitterEl: HTMLElement) => void;
	onResize?: (elementId: ResizeElementId, event: ResizeEvent, splitterEl: HTMLElement) => void;
	onStopResize?: (elementId: ResizeElementId, event: ResizeEvent, splitterEl: HTMLElement) => void;
	registerElement?: (elementId: ResizeElementId, data: IResizeElementData) => void;
	unregisterElement?: (elementId: ResizeElementId) => void;
}
